import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useAdminPage() {
  // Data
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);

  // UI
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'users';
  const setActiveTab = (tab) => setSearchParams(prev => { const next = new URLSearchParams(prev); next.set('tab', tab); return next; });
  const [editMode, setEditMode] = useState(null);

  return {
    users,
    setUsers,
    roles,
    setRoles,
    permissions,
    setPermissions,
    loading,
    setLoading,
    error,
    setError,
    success,
    setSuccess,
    activeTab,
    setActiveTab,
    editMode,
    setEditMode
  };
}
